export const listtypes = {
  radio: "LIST",
  checkmultilist: "LIST",
  customlist: "LIST",
  combobox: "BOX",
  listbox: "BOX",
  multilist: "BOX"
};

export const choosemultiple = {
  radio: false,
  checkmultilist: true,
  customlist: true,
  combobox: false,
  listbox: false,
  multilist: true
};
